import SignUp from './SignUp'
import enhance from './SignUp.enhancer'

export default enhance(SignUp)



// WEBPACK FOOTER //
// ./src/routes/public/Login/components/SignUp/index.js